/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} AccountInputs */

const en_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const es_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuenta`)
};

const fr_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compte`)
};

const de_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto`)
};

const ja_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウント`)
};

const zh_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`账号`)
};

const ar_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحساب`)
};

const id_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akun`)
};

const it_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account`)
};

const ru_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аккаунт`)
};

const pt_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conta`)
};

const ko_account = /** @type {(inputs: AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정`)
};

/**
* | output |
* | --- |
* | "Account" |
*
* @param {AccountInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const account = /** @type {((inputs?: AccountInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<AccountInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_account(inputs)
	if (locale === "es") return es_account(inputs)
	if (locale === "fr") return fr_account(inputs)
	if (locale === "de") return de_account(inputs)
	if (locale === "ja") return ja_account(inputs)
	if (locale === "zh") return zh_account(inputs)
	if (locale === "ar") return ar_account(inputs)
	if (locale === "id") return id_account(inputs)
	if (locale === "it") return it_account(inputs)
	if (locale === "ru") return ru_account(inputs)
	if (locale === "pt") return pt_account(inputs)
	return ko_account(inputs)
});